import React from 'react'
import PropTypes from 'prop-types'

const Icon = ({ content, className }) => {
  const renderIcon = () => {
    const { title, type } = content;
    
    switch (type) {
      case `list-menu`:
        return (
          <svg xmlns="http://www.w3.org/2000/svg" aria-labelledby="title"
            x="0px" 
            y="0px"
            width="344.339px"
            height="344.339px"
            viewBox="0 0 344.339 344.339"
            className={className}
            style={{ enableBackground: `new 0 0 344.339 344.339` }}
          >
            <title id="title">{title}</title>
            <g>
              <g>
                <g>
                  <rect y="46.06" width="344.339" height="29.52" />
                </g>
                <g>
                  <rect y="156.506" width="344.339" height="29.52" />
                </g>
                <g>
                  <rect y="268.748" width="344.339" height="29.531" />
                </g>
              </g>
            </g>
          </svg>
        );

        case `cancel`:
          return (
            <svg xmlns="http://www.w3.org/2000/svg" aria-labelledby="title"
              x="0px"
              y="0px"
              viewBox="0 0 241.171 241.171"
              className={className}
              style={{ enableBackground: `new 0 0 241.171 241.171` }}
            >
              <title id="title">{type}</title>
              <g>
                <path
                  d="M138.138,120.754l99.118-98.576c4.752-4.704,4.752-12.319,0-17.011c-4.74-4.704-12.439-4.704-17.179,0l-99.033,98.492L21.095,3.699c-4.74-4.752-12.439-4.752-17.179,0c-4.74,4.764-4.74,12.475,0,17.227l99.876,99.888L3.555,220.497c-4.74,4.704-4.74,12.319,0,17.011c4.74,4.704,12.439,4.704,17.179,0l100.152-99.599l99.551,99.563c4.74,4.752,12.439,4.752,17.179,0c4.74-4.764,4.74-12.475,0-17.227L138.138,120.754z"
                />
              </g>
            </svg>
          );

        break;

        case `down-arrow`:
          return (
            <svg xmlns="http://www.w3.org/2000/svg" aria-labelledby="title"
              x="0px" 
              y="0px"
              viewBox="0 0 59.414 59.414"
              className={className}
              style={{ enableBackground: `new 0 0 241.171 241.171` }}
            >
              <title id="title">{type}</title>
              <g>
                <polygon points="58,14.146 29.707,42.439 1.414,14.146 0,15.561 29.707,45.268 59.414,15.561 "/>
              </g>
            </svg>
          );

        break;

        case `up-arrow`:
          return (
            <svg xmlns="http://www.w3.org/2000/svg" aria-labelledby="title"
              x="0px" 
              y="0px"
              viewBox="0 0 59.415 59.415"
              className={className}
              style={{ enableBackground: `new 0 0 59.415 59.415` }}
            >
              <title id="title">{type}</title>
              <g>
                <polygon points="29.708,14.147 0,43.854 1.414,45.268 29.708,16.975 58,45.268 59.415,43.854 "/>
              </g>
            </svg>
          );

        break;
        
      default:
        return null;

        break;
    }
  };

  return (
    <React.Fragment>
      {renderIcon()}
    </React.Fragment>
  );
}

Icon.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired
  }),
}

export default Icon;